<!--Newsletter Start-->
<section class="stay-uptodate">
    <div class="container">
      <div class="heading">
        <div class="img"></div>
        <div class="text">
          <h2>Stay up <span>to Date</span></h2>
          <p>Scbscribe now and receive the latest travel news.</p>
        </div>
      </div>
      <form class="form">
        <div class="block">
          <div class="input-field outline">
            <input type="email" class="form-control" required placeholder="Your Name">
          </div>
        </div>
        <div class="block">
          <div class="input-field outline">
            <input type="email" class="form-control" required placeholder="Email ID">
          </div>
        </div>
        <a>subscribe</a>
      </form>
    </div>
  </section>
  <!--Newsletter End--> 
  
  <!--Download Mobile App start-->
  <section class="downloadmobile-app">
    <div class="container">
      <h2>Download<span>Our Mobile App</span> </h2>
      <div class="center-block">
        <div class="imgbloack"> <a href="https://play.google.com/store/apps/details?id=com.akbartravel.AkbarTravels" target="_blank"
                        class="googleplay"></a> <a href="https://itunes.apple.com/in/app/facebook/id955378983?mt=8" target="_blank"
                        class="appstore"></a> </div>
        <h3>Get Download link on your Mobile</h3>
        <form>
          <div class="form">
            <div class="block">
              <div class="form-group">
                <input type="email" class="form-control" id="loginMobile" required placeholder="Enter Your Mobile Number">
              </div>
            </div>
            <a>Send Link to my Mobile</a> </div>
        </form>
      </div>
      <div class="qrcode-block">
        <div class="qrcode"></div>
        <p>Scan the QR Code to download the Akbartravels Mobile App</p>
      </div>
    </div>
  </section>
  <!--Download Mobile App End--> 